import { FC } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectHouseAreaFilter } from 'shared/selectors/advancedFilters';

export const HouseAreaContainer: FC = () => {
  const { label, valueMax, valueMin, max, min, visible } = useSelector(selectHouseAreaFilter);

  const onChange = useFilterChangeCallback();

  const handleMinChange = useDebouncedCallback((newValue: number | null) => {
    onChange({ action: 'setTotalAreaMin', arguments: [newValue] });
  });

  const handleMaxChange = useDebouncedCallback((newValue: number | null) => {
    onChange({ action: 'setTotalAreaMax', arguments: [newValue] });
  });

  /* istanbul ignore next */
  if (!visible) {
    return null;
  }

  return (
    <InlineFilter width={100} postfix={'м\u00b2'} label={label} dataTestId="houseArea">
      <RangeInput
        min={min}
        max={max}
        valueMin={valueMin}
        valueMax={valueMax}
        onChangeMin={handleMinChange}
        onChangeMax={handleMaxChange}
      />
    </InlineFilter>
  );
};
